import { SerializableType } from '../types';

const paramsRegex = /{(\w+)}/g;

export function urlFormatParams(url: string, params: Record<string, SerializableType>): string {
  return url.replace(paramsRegex, (substring: string, paramName: string) => params[paramName]?.toString() || '');
}
